import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import PostAction from "../store/post/action";
import AppAction from "../store/app/action";
import FavoritesActions from "../store/favorites/action";
import LoadingView from "../components/LoadingView";
import ProductCard from "../components/ProductCard";
import { categoryLabels } from "../utils/categoryData";
import { ClothesTypes } from "../models/clothes/clothes.model";
import Clothes from "../models/clothes/clothes.model";

const POSTS_PER_PAGE = 50;

const ClothesByCategory = () => {
    const { type } = useParams<{ type: string }>();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((s) => s.auth);
    const { data: appData } = useAppSelector((s) => s.app);
    const { isLoading, postsByCategoryData, error } = useAppSelector((s) => s.post);
    const { favorites } = useAppSelector((s) => s.favorites);

    const categoryType = type as ClothesTypes | undefined;
    const isValidType = categoryType && Object.keys(categoryLabels).includes(categoryType);

    useEffect(() => {
        if (!categoryType || !isValidType) return;
        AppAction.getAppData(dispatch);
    }, [dispatch, categoryType, isValidType]);

    useEffect(() => {
        if (!categoryType || !isValidType) return;
        const perPage = appData?.posts_per_page?.other ?? POSTS_PER_PAGE;
        PostAction.getPostsByCategory(perPage, categoryType, dispatch);
    }, [dispatch, categoryType, isValidType, appData?.posts_per_page?.other]);

    const onItemClick = (item: Clothes) => {
        navigate("/item", { state: { item } });
    };

    const onToggleFavorite = (item: Clothes, e: React.MouseEvent) => {
        e.stopPropagation();
        if (FavoritesActions.isFavorite(item, favorites)) {
            FavoritesActions.removeItem(item, favorites, dispatch);
        } else {
            FavoritesActions.addItem(item, favorites, dispatch);
        }
    };

    if (!isValidType) {
        return (
            <div className="min-h-screen bg-[#f8f2ed]">
                <Navbar />
                <div className="p-4">Kategoria nuk u gjet.</div>
            </div>
        );
    }

    const list = postsByCategoryData || [];

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <h1 className="text-2xl font-semibold text-[#704e37] mb-6">
                    {categoryLabels[categoryType]}
                </h1>
                {isLoading && <LoadingView size={50} />}
                {error && <p className="text-red-500">{error}</p>}
                {!isLoading && !error && (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                        {list.map((item) => (
                            <ProductCard
                                key={`${item.seller_id}_${item.id}`}
                                item={item}
                                isFavorite={FavoritesActions.isFavorite(item, favorites)}
                                onToggleFavorite={onToggleFavorite}
                                onClick={onItemClick}
                                currentUserId={user?.id}
                            />
                        ))}
                    </div>
                )}
                {!isLoading && !error && list.length === 0 && (
                    <p className="text-gray-500">Nuk ka veshje në këtë kategori.</p>
                )}
            </div>
        </div>
    );
};

export default ClothesByCategory;
